export const MAX_NUM_BLOCKS = 800;
